<script lang="ts">import { getContext } from 'svelte';
import CarouselButton from '../CarouselButton/CarouselButton.svelte';
// prettier-ignore
const { parentBackgroundColor = 'white', class: className = '', ...rest } = $props();
const carouselContext = getContext('carousel');
const canScrollPrev = carouselContext?.canScrollPrev;
const canScrollNext = carouselContext?.canScrollNext;
</script>

<div
  {...rest}
  class="CarouselButtonGroup {className}"
  class:CarouselButtonGroup--visible={$canScrollPrev || $canScrollNext}
  role="group"
  aria-label="carousel navigation"
>
  <CarouselButton direction="previous" disabled={!$canScrollPrev} {parentBackgroundColor} />
  <CarouselButton direction="next" disabled={!$canScrollNext} {parentBackgroundColor} />
</div>

<style>/**
 * Do not edit directly, this file was auto-generated.
 * Wed, 16 Jul 2025 20:39:39 GMT
 */
/**
 We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
 */
@layer design-system-components.pwds {
  .CarouselButtonGroup {
    display: none;
    gap: var(--space-10);
  }
  @media (min-width: 64rem) {
    .CarouselButtonGroup {
      gap: var(--space-20);
    }
  }
  .CarouselButtonGroup--visible {
    display: flex;
  }
}</style>
